/* Mobile sticky add-to-cart bar. Delegates to the theme's own button. */
(() => {
  'use strict';
  const bar = document.querySelector('[data-bc-sticky-atc]');
  const main = document.querySelector('[data-product-wrapper] .product-form--atc-button');
  if (!bar || !main || !('IntersectionObserver' in window)) return;

  const button = bar.querySelector('[data-bc-sticky-button]');
  const phone = window.matchMedia('(max-width: 719px)');
  let mainInView = true;

  function update() {
    const show = phone.matches && !mainInView && !main.disabled;
    bar.hidden = !show;
    document.body.classList.toggle('bc-sticky-atc-visible', show);
  }

  new IntersectionObserver((entries) => {
    mainInView = entries[entries.length - 1].isIntersecting;
    update();
  }).observe(main);

  // Sold out or unavailable variant: the theme disables its button, so hide the bar too.
  new MutationObserver(update).observe(main, { attributes: true, attributeFilter: ['disabled'] });
  phone.addEventListener('change', update);

  button.addEventListener('click', () => {
    if (button.hasAttribute('data-bc-sticky-choose')) {
      const form = main.closest('form') || main;
      form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      const firstOption = form.querySelector('select, input[type="radio"]');
      if (firstOption) firstOption.focus({ preventScroll: true });
      return;
    }
    main.click();
  });
})();
